export class ActionDashboardCountModel {
    actionCount = 0;
    generalAlertsCount = 0;
    actionItemTypeCount = 0;
    carrierCategoryCount = 0;
    alertCount = 0;
    updateCount = 0;
}

export class TracItDashboardCountModel {
    tracItEntriesCount = 0;
    categoriesCount = 0;
    carrierTypesCount = 0;
    tracItUpdatesCount = 0;
    tracItAlertsCount = 0;
}
